import { useEffect, useState } from "react";
import { Phone, ArrowRight } from "lucide-react";

const StickyMobileCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 inset-x-0 z-50 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-card border-t border-border shadow-[0_-8px_30px_rgba(0,0,0,0.12)] grid grid-cols-2 gap-2 p-3">
        <a
          href="tel:+13237841577"
          className="flex items-center justify-center gap-2 py-3 rounded-xl bg-secondary text-secondary-foreground font-semibold text-sm"
        >
          <Phone className="w-4 h-4" />
          Call now
        </a>
        <a
          href="#audit-form"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center justify-center gap-2 py-3 rounded-xl btn-gold font-semibold text-sm"
        >
          Free audit
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
